import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SendEmailResponce } from 'services/requests';
import { useNavigate } from 'hooks/routes';
import { MutationKeys } from 'constants/mutationKeys';
import { showSuccessToast } from 'components/Toast';

type ForgotPasswordConfirmPayload = {
  email: string;
  message?: string;
};

export const useSendForgotPassword = () => {
  const mutate = async ({ email }: ForgotPasswordConfirmPayload) => {
    const { data } = await api.sendForgotPassword(email);

    return data;
  };

  const mutationKey = MutationKeys.sendForgotPassword;

  const { toForgotPasswordVerify } = useNavigate();

  return useMutation<
    SendEmailResponce,
    AxiosError<ApiError>,
    ForgotPasswordConfirmPayload
  >(mutationKey, mutate, {
    onSuccess: (data, { email, message }) => {
      toForgotPasswordVerify({ email });
      if (message) {
        showSuccessToast(message);
      }
    },
  });
};
